import React from "react";
import IconHeadquarters from "../icon/IconHeadquarters";
import SimpleBox from "../layout/container/SimpleBox";
import IconHandball from "../icon/IconHandball";
import { Link, Typography } from "@mui/material";

const Address = ({ title, type, address, postCode, link }) => {
    const IconComponent = type === "handball" ? IconHandball : IconHeadquarters;
    return (
        <SimpleBox flexDirection="column" gap={2}>
            <IconComponent />
            <SimpleBox flexDirection="column" gap={1}>
                <Typography variant="h6">{title}</Typography>
                <Typography fontSize="0.9rem">{address}</Typography>
                <Typography fontSize="0.9rem">{postCode}</Typography>
                <Link href={link} target="_blank" rel="noreferrer" underline="hover" fontSize="0.8rem">Mapa</Link>
            </SimpleBox>
        </SimpleBox>
    );
}

export default Address;
